import { render, staticRenderFns } from "./Not-Verified.vue?vue&type=template&id=dc6489cc&"
import script from "./Not-Verified.vue?vue&type=script&lang=js&"
export * from "./Not-Verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports